import { orderedActorsOf } from '../../../Actors/utils/actors-order.util';

interface ReferencedActor {
  readonly categoryIds: readonly string[];
  readonly thirdParty: Readonly<{
    name?: string | null;
    fullName?: string | null;
    lastName?: string | null;
    firstName?: string | null;
  }>;
  readonly references: readonly Readonly<{ typeId: string; value: string }>[];
}

// One line per external actor giving references to the entity, the quotation receivers first,
// then alphabetically: « Références ALBINGIA : Sinistre DOS267156 / Contrat DO1912267 ».
export const externalReferencesLinesOf = ({
  actors,
  quotationReceiverCategoryId,
  documentLabelOf,
}: Readonly<{
  actors: readonly ReferencedActor[];
  quotationReceiverCategoryId: string;
  // The type of a reference as the documents tell it, none for a plain reference.
  documentLabelOf: (typeId: string) => string | null | undefined;
}>): readonly string[] =>
  orderedActorsOf(
    actors.filter(({ references }) => references.length),
    quotationReceiverCategoryId,
  ).map(({ thirdParty, references }) => {
    const name = thirdParty.name ?? thirdParty.fullName ?? '';
    const values = references
      .map(({ typeId, value }) =>
        [documentLabelOf(typeId), value].filter(Boolean).join(' '),
      )
      .join(' / ');

    return `${references.length > 1 ? 'Références' : 'Référence'} ${name} : ${values}`;
  });
